// Presupuesto de venta y comprobante de venta, diseño limpio (18-oct-2026). Igual que el trabajo,
// pero cada producto lleva su miniatura (hay que mostrar lo que se vende) y no hay fotos de equipo.
import { cargarFoto } from '../helpers.js';
import { montosDescuento } from '../pdfShared.js';
import { datos, parrafo, tabla, totales, firmas, colCliente, plata } from './base.js';

export async function generarVentaV2(doc, {
    ctx, ticketItems, cliente, sede, y, esPresupuesto = true,
    firmaCliente, firmaTecnico, aclaracionCliente = '', aclaracionTecnico = '',
    descuentoPorcentaje = 0, descuentoAlcance = 'TOTAL', totales: tot = null, leyenda = '', sinPrecios = false,
    condicionIva = null, pctEfectivo = 0, cobradoEfectivo = false, montoCobrado = null,
}) {
    y = datos(doc, y, colCliente(cliente, sede), esPresupuesto
        ? { rotulo: 'Condiciones', lineas: ['Sujeto a disponibilidad de stock.', 'El pedido se prepara al confirmar el pago.'] }
        : null);

    // Productos (con miniatura) y el envío como un renglón más
    const filas = [];
    const minis = [];
    let bruto = 0;
    for (const it of ticketItems) {
        for (const r of (it.repuestosUsados || [])) {
            const cant = Number(r.cantidad || 1);
            const unit = Number(r.precio || 0);
            const imp = Number(r.subtotal ?? unit * cant);
            bruto += imp;
            const desc = String(r.descripcion || '').trim();
            const nombre = desc ? `${r.nombre || 'Producto'}\n${desc}` : (r.nombre || 'Producto');
            filas.push(sinPrecios ? [nombre, String(cant)] : [nombre, String(cant), plata(unit), plata(imp)]);
            minis.push(await cargarFoto(r.fotoUrl || null, 300, 0.8).catch(() => null)); // eslint-disable-line no-await-in-loop
        }
        const envio = parseFloat(it.costoExtra || 0);
        if (envio > 0) {
            bruto += envio;
            filas.push(sinPrecios ? ['Envío', '1'] : ['Envío', '1', plata(envio), plata(envio)]);
            minis.push(null);
        }
    }
    y = tabla(doc, ctx, y, sinPrecios
        ? [{ titulo: 'Producto' }, { titulo: 'Cant.', ancho: 16, derecha: true }]
        : [{ titulo: 'Producto' }, { titulo: 'Cant.', ancho: 14, derecha: true }, { titulo: 'Unitario', ancho: 30, derecha: true }, { titulo: 'Importe', ancho: 30, derecha: true }],
        filas, { miniaturas: minis, altoMiniatura: 13 });

    if (!sinPrecios) {
        const md = montosDescuento({ totalBruto: bruto, descuentoPorcentaje, descuentoAlcance, totales: tot });
        y = totales(doc, ctx, y, {
            subtotal: md.subtotal, descuentos: md.descuento > 0 ? [{ label: md.label, monto: md.descuento }] : [], total: md.total,
            condicionIva, esPresupuesto, pctEfectivo, cobradoEfectivo, montoCobrado,
            notas: ['Garantía de fábrica según cada producto'],
        });
    }
    if (String(leyenda || '').trim()) y = parrafo(doc, ctx, y, 'Observaciones', leyenda, { maxRenglones: 4 });
    y = firmas(doc, ctx, y + 4, { firmaCliente, firmaTecnico, aclaracionCliente, aclaracionTecnico, rolTecnico: 'Dispenser La Tienda' });
    return y;
}
